module.exports = __webpack_public_path__ + "img/Art09-19670070-014.aaceecc2.jpg";